exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-backdrop[data-v-898466b6]{z-index:-1!important}label[data-v-898466b6]{font-weight:600}.modal-g-forms[data-v-898466b6]{max-width:56%!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-898466b6","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/PrintFeedbackForm.vue
// module id = Ou2e
// module chunks = 101